import { UserData } from "@/lib/global/actions";
import { useSelection } from "@frend-digital/centra/client";
import { CustomAdapter, EventSubscription } from "@frend-digital/events/client";
import { depictAdapter } from "@frend-digital/events/depict";
import {
  BeforeEvent,
  centraGTMAdapter,
  selectionItemToGTAGProduct,
} from "@frend-digital/events/gtm";
import { useMemo } from "react";
import { getDepictMarketFromPricelistId } from "../products/[...category]/serverUtils/helpers";
import { md5, utf8_encode } from "./hash";

const logAdapter = () =>
  new CustomAdapter(e => {
    console.log(e.event, e.data);
  });

const Events = () => {
  const { data: selection } = useSelection();

  const adapters = useMemo(() => {
    const beforeGtmEvent: BeforeEvent = async e => {
      if (e.event === "purchase") {
        if (window?.ADT?.Tag) {
          /* AdTraction */
          window.ADT.Tag.t = 3;
          window.ADT.Tag.tp = 1909755022;
          window.ADT.Tag.c = e.ecommerce.currency;
          window.ADT.Tag.am = 0;

          let adtValue = e.ecommerce.value;
          if (typeof e.ecommerce.shipping === "number")
            adtValue -= e.ecommerce.shipping;
          if (typeof e.ecommerce.tax === "number") adtValue -= e.ecommerce.tax;
          window.ADT.Tag.am = adtValue;
          window.ADT.Tag.ti = e.ecommerce.transaction_id;
          if (selection?.selection?.address?.email) {
            window.ADT.Tag.xd = md5(
              utf8_encode(
                selection?.selection?.address?.email?.trim()?.toLowerCase(),
              ),
            );
          }

          window.ADT.Tag.cpn =
            typeof e.ecommerce.coupon === "string"
              ? e.ecommerce.coupon
              : e.ecommerce.coupon || "";
          window.ADT?.Tag?.doEvent();
        }
      }

      const userData: UserData = {};

      const result = {
        ...e,
        ...userData,
      };

      return result;
    };
    return [
      centraGTMAdapter({
        beforeEvent: beforeGtmEvent,
        selection: selection,
        formatter: item => {
          return {
            ...selectionItemToGTAGProduct(item),
            gtin: item.ean || "",
            mpn: item.sku || "",
            facebook_feed_g_id: item.ean || "",
          };
        },
      }),
      /*       logAdapter(), */
      depictAdapter("camillapihl", {
        market:
          getDepictMarketFromPricelistId(
            String(selection?.location?.pricelist),
          ) ?? "us",
      }),
    ];
  }, [selection]);

  return <EventSubscription adapters={adapters} />;
};

export default Events;
